/* eslint-disable i18next/no-literal-string */
export class Configuration {
  public static SignOutUrl = '/MicrosoftIdentity/Account/SignOut';

  public static FamilyUrl = 'https://account.microsoft.com/family/';

  public static ProductName = 'Defender';

  public static FullProductName = 'Microsoft Defender';

  public static ExperianName = 'Experian';

  public static AppStoreNames = {
    Apple: 'Apple App Store',
    Google: 'Google Play Store',
    Microsoft: 'Microsoft Store',
  };
}
